import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import dashboardImg_1 from 'Images/public/datasubmission/Dashboard_image_1.svg';
import dashboardImg_2 from 'Images/public/datasubmission/Dashboard_image_2.svg';
import dashboardImg_3 from 'Images/public/datasubmission/Dashboard_image_3.svg';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { ICONS } from 'Utils/icons';
import { IconTextButton, TextButton } from 'Components/Button';
import { NumberedSteps } from 'Components/Public/NumberedSteps/NumberedSteps';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { FloatingCallToAction } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
import { DidFindPrompt } from 'Components/Public/DidFindPrompt/DidFindPrompt';
import { NextPage } from 'Components/Public/NextPage/NextPage';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import { handleFileDownload, isLoggedIn, openInNewTab } from 'Utils/utilityFunctions';

function DataSubmission () {

    const navigate = useNavigate();
    const step4Text =
      <>
          <p>
              After protecting and mapping your data, select the submission method that best fits your workflow. The PSOPPC supports multiple submission options and formats, including manual uploads of Patient Safety Event (PSE) Data CDA XML, XML, or CSV files, as well as automated submissions through a Secure File Transfer Protocol (SFTP) connection.
          </p>
          <p>
              Use the resources below to understand each option, review technical requirements, and access detailed instructions for submitting patient safety data.
          </p>
      </>;
    return (
        <>
            <Row className="m-0 p-0">

                <PageHeader
                    title="Submit Data"
                    intro="By securely sharing your PSO's patient safety data with PSOPPC, you contribute to national learning that helps improve the quality of care."
                >
                    <h2 className="public-title text-center mb-3">Insights from submitted data</h2>
                    <Row className="public-cards col-gap-2 row-gap-3">
                        <Col md={4} lg={4}>
                            <Card className="h-100">
                                <Card.Body>
                                    <p className="public-card-header">The NPSD Dashboards</p>
                                    <div className="public-card-content align-items-start mb-3">
                                    	{/* remove alt text="NPSD Dashboard" for the image, it cause redundant alternative text 508 alert */}
                                        <img alt="" className="mb-2 maxHeight--100 w-100" src={dashboardImg_1} ></img>
                                        <p>Almost three-fourths of incident blood events during 2024 involved red blood cells as the type of blood product.</p>
                                    </div>
                                    <div className="public-card-footer">
                                        <IconTextButton 
                                            variant={'clear'} 
                                            icon={ICONS.launch} 
                                            className="reverse p-0 text-start" 
                                            content={'View NPSD Dashboards'}
                                            onClick={() =>
                                                openInNewTab('https://www.ahrq.gov/npsd/data/dashboard/index.html')
                                            }
                                        ></IconTextButton>
                                       
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} lg={4}>
                            <Card className="h-100">
                                <Card.Body>
                                    <p className="public-card-header">Hospital Version 1.2 Clinical Dashboards*</p>
                                    <div className="public-card-content align-items-start mb-3">
                                        <img alt="NPSD Chartbook" className="mb-2 maxHeight--120 w-100" src={dashboardImg_2}></img>
                                        <p>
                                            Incidents of unknown harm dropped from 10.4% in 2020 to 3.2% in 2023.

                                        </p>
                                    </div>
                                    
                                    <div className="public-card-footer text-start">
                                        <p className={`public-card-footer-note`}>
                                            *Clinical National Dashboards are available to submitting PSOs. The data above is sample data.
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} lg={4}>
                            <Card className="h-100">
                                <Card.Body>
                                    <p className="public-card-header">The NPSD Chartbooks</p>
                                    <div className="public-card-content align-items-start mb-3">
                                        <img alt="PSOPPC Clinical Dashboard" className="mb-2 maxHeight--120 w-100" src={dashboardImg_3}></img>
                                        <p>In 2024, 77.1% of pressure injury events were reported to have pressure injury preventive intervention in place.</p>
                                    </div>
                                    <div className="public-card-footer">

                                        <IconTextButton 
                                            variant={'clear'} 
                                            icon={ICONS.launch} 
                                            className="reverse p-0 text-start" 
                                            content={'View NPSD Chartbooks'}
                                            onClick={() =>
                                                openInNewTab('https://www.ahrq.gov/npsd/data/chartbook/index.html')
                                            }
                                        ></IconTextButton>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </PageHeader>


                <Row lg={10} className="main-content m-0  mb-4 mt-4   pt-4 pb-4 d-flex  align-items-center flex-column-reverse row-2 flex-lg-row justify-content-center mb-0">

                    <Col lg={6} className="m-0 p-0 mt-5 col-11">
                        <div className="step-title d-block d-md-grid m-0 p-2 p-md-0">
                            <h3 className="text-start">
                                Follow these steps to securely submit your data
                            </h3>
                        </div>
                        <div className="steps">
                            <NumberedSteps
                                number={'01'}
                                stepTitle="Sign a Data Use Agreement"
                                stepText={"Your data is sensitive and valuable. Before you submit any data, our team will send you a DocuSign for an agreement that clearly outlines how your data may be used, how long we may use data, and how data will be protected."}
                            >
                                <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                    <IconTextButton 
                                        variant={'normal'} 
                                        icon={ICONS.download} 
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        content={'Learn about the DUA'}
                                        onClick={() =>
                                            handleFileDownload(552)
                                        }
                                    ></IconTextButton>
                                    <IconTextButton
                                        variant="outline"
                                        icon={ICONS.mailoutlined} 
                                        content="Contact us to sign a DUA"
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        href="mailto:support@psoppc.org"
                                    /* onClick={() =>
                                            navigate("")
                                        }*/>
                                    </IconTextButton>
                                </div>
                            </NumberedSteps>
                            <NumberedSteps
                                number={'02'}
                                stepTitle="Protect the data"
                                stepText={"Our number one priority is protecting the identities of patients, providers, and reporters. When submitting data to PSOPPC, we ask that PSOs assign unique Provider IDs to their member providers so information can’t be tracked back to an individual or facility. Any identifying information found in free-form text fields will never be sent to the NPSD."}
                            >
                                <TextButton
                                    variant="normal"
                                    content="How we will protect your data"
                                     className="w-xs-100 w-sm-fit-content justify-content-center"
                                    onClick={() =>
                                        navigate(PATHS.public['Data Security'])
                                    }
                                ></TextButton>
                            </NumberedSteps>
                            <NumberedSteps
                                number={'03'}
                                stepTitle="Use Common Formats"
                                stepText={"To help us compare your data to data from other PSOs, we ask that you map to the Common Formats. Our team stands ready to help you with mapping when you're ready for this step."}
                            >
                                <TextButton
                                    variant="normal"
                                    content="Learn more about Common Formats"
                                     className="w-xs-100 w-sm-fit-content justify-content-center"
                                    onClick={() =>
                                        navigate(PATHS.public['Use Common Formats'])
                                    }
                                ></TextButton>
                            </NumberedSteps>
                            <NumberedSteps
                                number={'04'}
                                stepTitle="Choose your submission method"
                                stepText={step4Text}
                            >
                                <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                    <IconTextButton 
                                        variant={'normal'} 
                                        icon={ICONS.download} 
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        content={'PSE Data Submission Overview'}
                                        onClick={() =>
                                            handleFileDownload(150)
                                        }
                                    ></IconTextButton>
                                    <IconTextButton 
                                        variant={'outline'} 
                                        icon={ICONS.download} 
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        content={'SFTP Data Submission User Manual'}
                                        onClick={() =>
                                            handleFileDownload(153)
                                        }
                                    ></IconTextButton>
                                    <IconTextButton 
                                        variant={'outline'} 
                                        icon={ICONS.download} 
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        content={'PSOPPC Web Service Users Manual'}
                                        onClick={() =>
                                            handleFileDownload(154)
                                        }
                                    ></IconTextButton>
                                    <IconTextButton 
                                        variant={'outline'} 
                                        icon={ICONS.download} 
                                        className="reverse text-center w-100 d-flex justify-content-center" 
                                        content={'Patient Safety Data Submission FAQs'}
                                        onClick={() =>
                                            handleFileDownload(151)
                                        }
                                    ></IconTextButton>
                                </div>
                                
                            </NumberedSteps>
                            <NumberedSteps
                                number={'05'}
                                stepTitle="Submit test data"
                                stepText={"Now you're ready to do a test submission. Try submitting a portion of your data as a test to make sure it clears all the necessary checks. You will get a report with any errors you need to fix."}
                            >
                                {   
                                    isLoggedIn() == true
                                    ?   null
                                    :   <TextButton variant="normal"  className="w-xs-100 w-sm-fit-content justify-content-center" content="Log in to submit test data" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton> 
                                }
                                
                            </NumberedSteps>
                            <NumberedSteps
                                number={'06'}
                                stepTitle="Review feedback"
                                stepText={"After submitting test data, you'll get a report that details any errors in the file structure or the data itself that you may need to fix before submitting production data to the PSOPPC."}
                            >
                                {   
                                    isLoggedIn() == true
                                    ?   null
                                    :   <TextButton variant="normal" content="Log in to review the reports"  className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton> 
                                }
                                
                            </NumberedSteps>
                            <NumberedSteps
                                number={'07'}
                                stepTitle="Submit all data anytime"
                                stepText={"Once you've fixed any errors in your test file, feel free to submit as much data as you'd like, as frequently as you'd like to the PSOPPC. Some PSOs choose to submit to us once a week while others submit once a quarter or once a year. Our team will review the data on an ongoing basis and work with the NPSD to publish insights regularly."}
                            >
                                {   
                                    isLoggedIn() == true
                                    ?   null
                                    :   <TextButton variant="normal" content="Log in to submit data"  className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton> 
                                }
                            </NumberedSteps>
                        </div>
                    </Col>


                    <FloatingCallToAction
                        title="Ready to submit?"
                        text={isLoggedIn() == true ? null : "Login in now to submit data."}
                    >
                        {   
                            isLoggedIn() == true
                            ?   <TextButton variant="normal" content="Submit Data" onClick={()=>navigate(PATHS.private.cda)}></TextButton> 
                            :   <TextButton variant="normal" content="Log In" onClick={()=>navigate(PATHS.public['Sign In'])}></TextButton> 
                        }
                    </FloatingCallToAction>

                </Row>

            </Row>
            {/*Commented as of UAT Bugfix - Revision of FAQs*/}
            {/*<Row className="faq m-0 d-flex justify-content-center">*/}
            {/*    <Col lg="10">*/}
            {/*        <h2 className="mb-5">Frequently Asked Questions</h2>*/}
            {/*        <PublicAccordion*/}
            {/*            defaultActiveKey={[]}*/}
            {/*            accordionItemsContent={[*/}
            {/*                {*/}
            {/*                    header: "If our reporting system is a 1:1 match with the  AHRQ Common Formats, do you use all data points if we send them to you, or do you only use a certain data set out of all the Common Formats?",*/}
            {/*                    content: "Unless the data is missing a required data field, the data is accepted by the import processor. Some data fields that may be used at the local level, mostly identifiers, are removed by the import processor for privacy protections. Please note that data submission/acceptance rules vary by submission format. For more information on our privacy protection measures, please view Educational Brief 49. The PSOPPC has also compiled a list of common questions associated with the patient safety data submission process which you can view here: Frequently Asked Questions."*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    header: "Do you accept and analyze 100% of the Common Formats or just a certain percentage?",*/}
            {/*                    content: "We do accept data across the Common Formats and their different versions, but not all data is ultimately included for analysis. There are global exclusions for Common Formats for Event Reporting - Hospital V1.2 (see Appendix A). In the case of resubmissions, only the most recent version of a reported event or safety concern is considered in yearly analyses. Also, there are some event types that data are accepted for, but are not included for public-facing analysis as there are not yet sufficient responses to meet non-identification requirements."*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    header: "If it is only a certain percentage, what data points make that percentage up?",*/}
            {/*                    content: "We strive to use as many records as possible! For example, about 98.0% of CFER-H V1.2 data that are submitted and accepted by the import processor are included in initial analyses, but there is variance across event types for data inclusion and publication of analyses. Apart from defined exclusions (see response to question #2), we do not publish analyses of some data elements that are too sparsely populated due to non-identification requirements. However, we encourage PSOs to submit Patient Safety data as more submissions enable more representative and richer analyses to be publicly available."*/}
            {/*                },*/}
            {/*                /* remove this ALT format FAQ - content is not accurate*/}
            {/*                {*/}
            {/*                    header: "For the "Question Group ID" field used to group related questions together within a section, is it a requirement to have more than one group of medications or equipment, or can we use a single group where we default to 1? We only capture a single device or medication per incident.",*/}
            {/*                    content: "It is not a requirement. You are able to submit a single group with the default group ID to "1".  However, the Common Formats do allow for reporting multiple devices or medications where applicable."*/}
            {/*                },*/}
            {/*                */}
            {/*            ]}*/}
            {/*        ></PublicAccordion>*/}
            
            {/*    </Col>*/}
            {/*</Row>*/}

            <DidFindPrompt></DidFindPrompt>
            <NextPage path={PATHS.public['Learn from the Data']} text="Learn from the Data"
                backPath={PATHS.public['Use Common Formats']} backPathText="Use Common Formats"
            ></NextPage>
                
        </>
    );
}

export default DataSubmission;
